import { ReactElement, useEffect, useState } from "react";
import * as React from "react";

import {
  LanguageRegion,
  LanguageRegionStatus,
} from "../../../generated/gql/graphql";
import useLanguageRegions from "../../../hooks/query/use-language-regions";
import useText from "../../../hooks/use-text";
import { parseType } from "../../../utils/graphql";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChange(languageRegion?: LanguageRegion): void;
};

export default function LanguageRegionSelector(props: Props): ReactElement {
  const { onChange } = props;

  const { strings } = useText(local);

  const [options, setOptions] = useState<LanguageRegion[]>([]);
  const { data } = useLanguageRegions({
    filter: {
      status: {
        eq: LanguageRegionStatus.Published,
      },
    },
  });

  useEffect(() => {
    if (!data) {
      return;
    }

    setOptions(parseType<LanguageRegion[]>("languageRegions", data));
  }, [data]);

  return (
    <MetaSelect
      label={strings.label}
      name="value"
      getOptions={options}
      setOption={(v) => onChange(v["value"])}
      list={options.map((v) => ({ text: v.name, value: v }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Language & Regions",
  },
};
